import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.252 1.568 16 1.421l-.252.147-12 7-.248.145V23.287l.248.145 12 7 .252.147.252-.147 12-7 .248-.145V8.713l-.248-.145-12-7ZM4.5 9.871v12.258L15.008 16 4.5 9.87ZM4.992 23 15.5 29.13V16.87L4.992 23ZM16.5 29.13 27.008 23 16.5 16.87v12.26Zm11-7V9.87L16.992 16 27.5 22.13ZM27.008 9 16.5 2.87v12.26L27.008 9ZM15.5 2.87 4.992 9 15.5 15.13V2.87Z",
  fill: "#C2C2C2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16 1.25a.746.746 0 0 0-.396.113l-2.49 1.494a.75.75 0 1 0 .772 1.286l1.364-.818V7.5a.75.75 0 0 0 1.5 0V3.325l1.364.818a.75.75 0 1 0 .772-1.286l-2.49-1.494A.747.747 0 0 0 16 1.25ZM28.658 12a.75.75 0 0 1-1.5 0v-1.452l-3.794 2.107a.75.75 0 1 1-.728-1.31l4.097-2.277-1.605-.917a.75.75 0 1 1 .744-1.302l2.408 1.375a.75.75 0 0 1 .378.65V12Zm0 8a.75.75 0 1 0-1.5 0v1.452l-3.794-2.107a.75.75 0 1 0-.728 1.31l4.097 2.277-1.605.917a.75.75 0 0 0 .744 1.303l2.408-1.375a.75.75 0 0 0 .378-.652V20ZM4.092 13.25a.75.75 0 0 1-.75-.75V8.875a.75.75 0 0 1 .378-.651l2.408-1.375a.75.75 0 1 1 .744 1.302l-1.606.917 4.098 2.277a.75.75 0 1 1-.729 1.31l-3.793-2.107V12.5a.75.75 0 0 1-.75.75ZM3.342 20a.75.75 0 0 1 1.5 0v1.452l3.793-2.108a.75.75 0 1 1 .729 1.312l-4.098 2.276 1.606.917a.75.75 0 0 1-.744 1.302L3.72 23.776a.75.75 0 0 1-.378-.65V20Zm12.262 10.637a.747.747 0 0 0 .793 0l2.489-1.494a.75.75 0 1 0-.772-1.286l-1.364.818V24.5a.75.75 0 1 0-1.5 0v4.175l-1.364-.818a.75.75 0 1 0-.772 1.286l2.49 1.494Zm-1.718-16.78a.75.75 0 0 0-.772 1.286l2.136 1.282V19a.75.75 0 0 0 1.5 0v-2.575l2.136-1.282a.75.75 0 1 0-.772-1.286L16 15.126l-2.114-1.269Z",
  fill: "#828282"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }